import React from 'react';
import HeroSection from './components/landingPage/HeroSection';
import Services from './components/landingPage/Services';
import WhyUs from './components/landingPage/WhyUs';
import Pricing from './components/landingPage/Pricing';
import Features from './components/landingPage/Features';
import Footer from './components/landingPage/Footer';

const Main = () => (
  <>
    <HeroSection />
    <Services />
    <WhyUs />
    <Pricing />
    <Features />
    <Footer />
  </>
);

export default Main;
